<template>
  <div class="conteneur">
    <div class="contact">
      <img src="../assets/contact.jpg" alt="" />
      <div class="text__contact">
        <p class="para_contact">
          <img src="../assets/mail.svg" alt="" />
          drolet.begin@gmail.com
        </p>
        <p class="para_contact">
          <img src="../assets/telephone.svg" alt="" />
          418-563-6819
        </p>
        <p class="para_contact">
          <a href="" class="sociaux"
            ><img src="../assets/facebook.svg" alt=""
          /></a>
          <a href="" class="sociaux"
            ><img src="../assets/linkedin.svg" alt=""
          /></a>
          <a href="" class="sociaux"
            ><img src="../assets/instagram.svg" alt=""
          /></a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
